// extracted by mini-css-extract-plugin
module.exports = {"container":"emailAfterPurchase_container__1g3Wk","createIcon":"emailAfterPurchase_createIcon__1vq9n"};